import ErrorCard from 'components/ErrorCard/ErrorCard';
import { useConsolidatedCheckout } from 'lib/context/ConsolidatedCheckoutContext/ConsolidatedCheckoutContext';
import styles from './CheckoutPageAlerts.module.scss';

/* CheckoutPageAlert */
export default function CheckoutPageAlerts() {
  const { submissionErrors, submissionErrorsAreVisible } =
    useConsolidatedCheckout();

  function generateSubmissionErrors() {
    return submissionErrors.map((errorMessage, idx) => (
      <div className={styles.checkoutPageAlert} key={`error-message-${idx}`}>
        <ErrorCard message={errorMessage} />
      </div>
    ));
  }

  return submissionErrorsAreVisible ? <>{generateSubmissionErrors()}</> : null;
}
/* */
